import { formatDateMoment, setNumberWithPoint } from 'utils/utils'

export const TABLE_POINT = {
    name: 'Activity',
    column: [
        {
            name: 'Point',
            key: 'amount',
            render: ({ value }) => (
                <div className={value < 0 ? 'text-red-50' : 'text-green-500'}>{setNumberWithPoint(value)}</div>
            ),
        },
        {
            name: 'Tanggal',
            key: 'created_at',
            render: ({ value }) => formatDateMoment(value, 'DD MMM YYYY'),
        },
        {
            name: 'Description',
            key: 'description',
            className: 'capitalize',
        },
    ],
}

export const INITIAL_DATA_FILTER = {
    page: 1,
    limit: 20,
}
